export class FilterPage {
    pageLimitOptions = [{ value: 5 }, { value: 10 }, { value: 25 }, { value: 50 }, { value: 100 }];
}


